import React, { Component } from 'react';
import SidebarMenuRouters from '../../routers/routers';
import Header from '../../containers/header';
import { COLORS } from '../../utils/constants';
import * as Parse from '../../utils/parsers';
import * as Format from '../../utils/formatters';
import SimpleMonthPicker from '../../components/ui-components/SimpleMonthPicker';
import TemplateCoverage from '../../charts/templateCoverage';
// import Trainings from '../../components/tables/trainings';
import PayrollCostGraph from '../../charts/payrollCost';
import AssociatesSatisfaction from '../../charts/associatesSatisfaction';

export const BoxSingle = (props) => {

  return (
    <div className="iconbox-single" style={{height: '80%', minWidth: '50%', marginBottom: '0', marginRight: '0' +
        ''}}>
      <div className="box-title">
        <div>
          <h5 style={{color: COLORS.SUMMARY_GREEN}}>{props.title}</h5>
          <p style={{color: COLORS.SUMMARY_GRAY}}>{props.subtitle}</p>
        </div>
      </div>
      <div className="chart">
        {props.children}
      </div>
    </div>
  )
};

class HumanResources extends Component{
  constructor(props) {
    super(props);
    let userData = JSON.parse(localStorage.getItem('userData'));
    let today = Parse.toCustomDateLastDay(new Date());
    let dateModal = Format.formatStringMonth(Parse.toGetMonth(today))+' '+Parse.toGetYear(today);
    this.state={ userData: userData, dateModal: dateModal, date: today }
  }

  callback = (dataFromChild) => {
    let date= Parse.toCustomDateLastDay(dataFromChild);
    let dateModal = Format.formatStringMonth(Parse.toGetMonth(date))+' '+Parse.toGetYear(date);
    this.setState({date: date, dateModal: dateModal, key: Math.floor(Math.random() * 11)});
  };

  render(){

    const authorization= (this.state.userData.name === 'Gestor de talento');

    return(
      <div>
        <SidebarMenuRouters profile="/direction-home/" place={''}/>
        <Header userName={this.state.userData.name} title={'Talento'}/>
        <div className='row'>
          <div className='col-lg-3 col-md-4 col-12 offset-lg-9 offset-md-8'>
            <BoxSingle
              title={<SimpleMonthPicker callbackFromParent={this.callback}/>}
              subtitle="Periodo">
            </BoxSingle>
          </div>
        </div>
        <div className={'row pr-0 pl-0'}>
          <div className={'col-12 pr-0 pl-0 '}>
            <TemplateCoverage key={this.state.key} date={this.state.date} authorization={authorization} dateModal={this.state.dateModal}/>
          </div>
        </div>
        {/*<div className={'row pr-0 pl-0'}>
          <div className={'col-12 pr-0 pl-0 '}>
            <Trainings key={this.state.key} date={this.state.date} authorization={authorization} dateModal={this.state.dateModal}/>
          </div>
        </div>*/}
        <div className={'row pr-0 pl-0'}>
          <div className={'col-12 pr-0 pl-0 '}>
            <PayrollCostGraph key={this.state.key} date={this.state.date} authorization={authorization} dateModal={this.state.dateModal}/>
          </div>
        </div>
        <div className={'row pr-0 pl-0'}>
          <div className={'col-12 pr-0 pl-0 '}>
            <AssociatesSatisfaction key={this.state.key} date={this.state.date} authorization={authorization} dateModal={this.state.dateModal}/>
          </div>
        </div>
      </div>
    );
  }
}

export default HumanResources;



// WEBPACK FOOTER //
// ./src/scene/human-resources/humanResources.js